import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Alert, Spinner } from "react-bootstrap";
import API_BASE_URL from "../config/api";

const AdminRegistrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("sparklogic_admin_token");

    const fetchRegistrations = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/registrations`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Failed to fetch registrations");
        }

        setRegistrations(result.registrations || []);
      } catch (err) {
        setError(err.message || "Unable to load registrations.");
      } finally {
        setLoading(false);
      }
    };

    if (!token) {
      setError("Please login as admin to view registrations.");
      setLoading(false);
      return;
    }

    fetchRegistrations();
  }, []);

  return (
    <Container className="page-shell my-5">
      <Row className="mb-4">
        <Col>
          <span className="eyebrow dark">Admin</span>
          <h1 className="mb-3">Registered Candidates</h1>
        </Col>
      </Row>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : registrations.length === 0 ? (
        <Card className="form-card border-0">
          <Card.Body className="p-4 text-center">
            <p className="mb-0">No registrations found yet.</p>
          </Card.Body>
        </Card>
      ) : (
        <Card className="form-card border-0">
          <Card.Body className="p-0">
            <div className="table-responsive">
              <Table striped bordered hover className="mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>WhatsApp</th>
                    <th>Qualification</th>
                    <th>Course</th>
                    <th>Reference</th>
                    <th>Registered</th>
                  </tr>
                </thead>
                <tbody>
                  {registrations.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.name || "-"}</td>
                      <td>{item.mobileNumber || "-"}</td>
                      <td>{item.whatsappNumber || "-"}</td>
                      <td>{item.qualification || "-"}</td>
                      <td>{item.course || "-"}</td>
                      <td>{item.referenceName || "-"}</td>
                      <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default AdminRegistrations;
